const productData = [
    {
        id: "1",
        title: "HDPE Pipe",
        image: "HDPE Pipe.png",
        file_name: "catalogue/HDPE_Pipe_Catalogue.pdf",
        description:
            "Polo LEO® High-density polyethylene (HDPE) pipes are a plastic piping system known for their exceptional durability, flexibility, and resistance to various environmental factors. Engineered for superior performance in challenging conditions.",
        composition: [
            "High-density polyethylene resin",
            "Virgin and recycled material blend",
            "UV stabilizers",
            "Processing aids",
        ],
        advantages: [
            "Excellent chemical and corrosion resistance",
            "High flexibility and impact resistance",
            "Low weight for easy installation",
            "Superior longevity - 50+ years lifespan",
            "Environment-friendly and recyclable",
            "Lower installation costs due to flexibility",
        ],
        applications: [
            "Water supply systems",
            "Gas distribution",
            "Drainage and sewer systems",
            "Agricultural irrigation",
            "Industrial applications",
            "Potable water transport",
        ],
        sizes: [
            "16mm to 250mm OD (Pressure pipes)",
            "16mm to 250mm OD (Drainage pipes)",
            "Custom sizes available on request",
        ],
    },
    {
        id: "2",
        title: "uPVC Pipe",
        image: "uPVC Pipe.png",
        file_name: "catalogue/uPVC_Pipe_Catalogue.pdf",
        description:
            "Polo LEO® unplasticized polyvinyl chloride (uPVC) pipes offer rigidity and strength combined with exceptional durability. Ideal for pressurized and non-pressurized applications with outstanding dimensional stability.",
        composition: [
            "Unplasticized polyvinyl chloride",
            "Impact modifiers",
            "Thermal stabilizers",
            "Processing additives",
        ],
        advantages: [
            "High rigidity and strength",
            "Excellent durability and weather resistance",
            "Superior dimensional stability",
            "Flame-retardant properties",
            "Low maintenance requirements",
            "Cost-effective solution",
            "Easy joining with solvent cement",
        ],
        applications: [
            "Water supply networks",
            "Sewerage systems",
            "Irrigation systems",
            "Chemical transport",
            "Industrial applications",
            "Underground and overhead installations",
        ],
        sizes: [
            "40mm to 315mm (Class 3 - High Pressure)",
            "63mm to 315mm (Class 2 - Medium Pressure)",
            "90mm to 315mm (Class 1 - Low Pressure)",
            "Custom specifications available",
        ],
    },
    {
        id: "3",
        title: "SWR Pipe (Soil, Waste, and Rainwater)",
        image: "SWR Pipe.png",
        file_name: "catalogue/SWR_Pipe(Soil, Waste, and Rainwater)_Catalogue.pdf",
        description:
            "Polo LEO® specialized stormwater and rainwater drainage pipes designed for efficient water management. Perfect for handling surface and storm water without pressure requirements.",
        composition: [
            "Rigid PVC compound",
            "Drainage-specific additives",
            "UV stabilizers",
            "Thermal stabilizers",
        ],
        advantages: [
            "Lightweight and easy to install",
            "Excellent corrosion resistance",
            "Superior flow characteristics",
            "Lower cost than pressurized pipes",
            "Environmentally sustainable",
            "Wide socket diameters for efficient drainage",
        ],
        applications: [
            "Stormwater drainage",
            "Rainwater harvesting systems",
            "Sewerage applications",
            "Industrial waste drainage",
            "Building ventilation systems",
            "Agricultural drainage",
        ],
        sizes: [
            "75mm to 160mm (Domestic applications)",
            "75mm to 160mm (Commercial applications)",
            "Custom sizes for large projects",
        ],
    },
    {
        id: "4",
        title: "Casing Pipe",
        image: "Casing Pipe.png",
        file_name: "catalogue/Casing_Pipe_Catalogue.pdf",
        description:
            "Polo LEO® chlorinated Polyvinyl Chloride (CPVC) casing pipes offer superior performance in high-temperature applications. Engineered for bore well and pump installations with exceptional durability.",
        composition: [
            "Chlorinated polyvinyl chloride",
            "Impact modifiers",
            "Thermal stabilizers",
            "Processing additives",
        ],
        advantages: [
            "Superior temperature resistance (up to 60°C)",
            "Excellent corrosion resistance",
            "High strength and rigidity",
            "Better performance in saline water",
            "Longer service life",
            "Reduced maintenance costs",
        ],
        applications: [
            "Bore well casing",
            "Pump installations",
            "High-temperature water supply",
            "Agricultural irrigation",
            "Industrial water systems",
            "Deep water exploration",
        ],
        sizes: [
            "48mm to 280mm (OD)",
            "Standard wall thickness options",
            "Custom specifications available",
        ],
    },
    {
        id: "5",
        title: "uPVC Column Pipe",
        image: "uPVC Column Pipe.jpeg",
        file_name: "catalogue/uPVC_Column_Pipe_Catalogue.pdf",
        description:
            "Specifically designed Polo LEO® column pipes for water lifting and pressure applications. Engineered to handle high pressures with superior tensile strength and rigidity.",
        composition: [
            "Virgin uPVC compound",
            "Pressure-resistant additives",
            "Impact modifiers",
            "UV and thermal stabilizers",
        ],
        advantages: [
            "High pressure handling capability",
            "Excellent axial strength",
            "Minimal water loss through seepage",
            "Corrosion-free operation",
            "Long-term reliability",
            "Reduced operational costs",
        ],
        applications: [
            "Water supply columns",
            "Submersible pump columns",
            "Agricultural water systems",
            "Municipal water supply",
            "Industrial applications",
            "High-rise building water systems",
        ],
        sizes: [
            "25mm to 100mm (OD)",
            "Class 2 and Class 3 options",
            "Various joining systems available",
        ],
    },
    {
        id: "6",
        title: "RS Pipe (Ribbed Screen)",
        image: "RS Pipe.png",
        file_name: "catalogue/RS_Ribbed_Screen_Pipe_Catalogue.pdf",
        description:
            "Polo LEO® advanced reinforced pipes combining rigid plastic properties with reinforcement for superior strength. Ideal for demanding underground and overhead applications.",
        composition: [
            "Modified PVC compound",
            "Steel or glass fiber reinforcement",
            "High-performance additives",
            "Thermal stabilizers",
        ],
        advantages: [
            "Exceptional strength and rigidity",
            "Superior load-bearing capacity",
            "Enhanced durability",
            "Reduced deformation",
            "Better performance in challenging soil conditions",
            "Cost-effective compared to metal pipes",
        ],
        applications: [
            "Underground cable protection",
            "Deep burial applications",
            "Industrial pipelines",
            "Agricultural drainage",
            "Infrastructure projects",
            "High-load bearing systems",
        ],
        sizes: [
            "52mm to 169mm (OD)",
            "Custom wall thicknesses available",
            "Project-specific configurations",
        ],
    },
    {
    id: "7",
    title: "Plumbing & Casing Pipe (ASTM D1785)",
    image: "Plumbing & Casing Pipe.png",
    file_name: "catalogue/Plumbing_Casing_Pipe_Catalogue.pdf",
    description:
        "Polo LEO® ASTM D1785 uPVC Plumbing & Casing Pipes are engineered for superior strength, durability, and pressure performance. Manufactured in three pressure classes—Schedule 40, Schedule 80, and Schedule 120—these pipes are ideal for plumbing, borewell casing, water supply, and industrial fluid conveyance applications.",
    composition: [
        "Unplasticized polyvinyl chloride (uPVC)",
        "Impact modifiers",
        "Thermal stabilizers",
        "Processing additives",
    ],
    advantages: [
        "Manufactured in Schedule 40, 80 & 120 for varied pressure requirements",
        "Precision-engineered threaded ends for secure, leak-proof joints",
        "Superior strength and high pressure performance",
        "Excellent corrosion and chemical resistance",
        "Long service life with reduced maintenance costs",
    ],
    applications: [
        "Plumbing & water supply",
        "Borewell casing",
        "Liquid chemical transportation",
        "Industrial fluid conveyance",
    ],
    sizes: [
        '1/2" to 12" (15mm to 300mm Nominal Inside Diameter)',
        "21.34mm to 323.85mm (Outer Diameter)",
        "Available in Schedule 40 (Light Duty), Schedule 80 (Medium Duty), and Schedule 120 (Heavy Duty)",
    ],
    },
    {
        id: "8",
        title: "Solvent Cement",
        image: "Solvent Cement.jpeg",
        file_name: "catalogue/Solvent_Cement_Catalogue.pdf",
        description:
            "Polo LEO® premium quality solvent cement specifically formulated for PVC and CPVC pipe jointing. Ensures strong, permanent, and watertight connections with ease of application.",
        composition: [
            "Cyclohexanone (primary solvent)",
            "Tetrahydrofuran (co-solvent)",
            "PVC resin",
            "Additives for improved bonding",
        ],
        advantages: [
            "Fast-setting and permanent bonds",
            "Water and pressure-tight joints",
            "Easy application process",
            "Superior adhesion quality",
            "Resistant to water and chemicals",
            "No additional equipment required",
            "Cost-effective solution",
        ],
        applications: [
            "PVC pipe jointing",
            "CPVC connections",
            "Socket and spigot joints",
            "Water supply systems",
            "Drainage systems",
            "Industrial piping",
            "Professional installations",
        ],
        sizes: [
            "100ml bottles",
            "250ml containers",
            "1-liter units",
            "Bulk quantities for contractors",
        ],
    },
];

export default productData;